module.exports = __webpack_public_path__ + "static/media/circle-border.8a0d7636.svg";